import { App } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from '~/app/login/login.module.css';
import { useLogin } from '~/app/auth/hooks/useLogin';

import { LoginBranding } from './LoginBranding';
import { LoginFooterBar } from './LoginFooterBar';
import { LoginFormCard } from './LoginFormCard';
import { LoginToolbar } from './LoginToolbar';
import { loginErrorMessage } from './loginErrorMessage';

export function LoginScreen() {
  const { message } = App.useApp();
  const loginMutation = useLogin();
  const { t } = useTranslation(['common', 'logIn']);

  const handleLogin = async (values: { email: string; password: string }) => {
    try {
      await loginMutation.mutateAsync(values);
      message.success(t('logIn:messages.success'));
    } catch (error: unknown) {
      message.error(
        loginErrorMessage(error, t('logIn:messages.invalidCredentialsDefault')),
      );
    }
  };

  const isLoading = loginMutation.isPending;

  return (
    <div className={styles.container}>
      <LoginToolbar />

      <LoginBranding subtitle={t('logIn:labels.subtitle')} />

      <LoginFormCard
        title={t('logIn:labels.title')}
        intro={t('logIn:descriptions.intro')}
        emailLabel={t('common:labels.email')}
        emailPlaceholder={t('common:placeholders.email')}
        emailRequired={t('common:errors.emailRequired')}
        emailInvalid={t('common:errors.emailInvalid')}
        passwordLabel={t('common:labels.password')}
        passwordPlaceholder={t('common:placeholders.password')}
        passwordRequired={t('common:errors.passwordRequired')}
        passwordMin={t('common:errors.passwordMin')}
        submitLabel={t('logIn:buttons.logIn')}
        forgotLabel={t('logIn:links.forgotPassword')}
        isLoading={isLoading}
        onSubmit={handleLogin}
      />

      <LoginFooterBar
        rightsReserved={t('common:footer.allRightsReserved', {
          year: new Date().getFullYear(),
          company: 'EVIMO',
        })}
      />
    </div>
  );
}
